import React from 'react';
import { connect } from 'react-redux';
import * as AppConfigActions from 'app/actions/app-config/actions';
import { ContactWelcomeLanding } from 'app/components/ContactWelcomeLanding';

/**
 * This component is used as part of the home equity turbo welcome form.  It uses
 * <ContactWelcomeLanding /> which handles the call-to-action page.
 *
 * @class ContactWelcomeComponent
 * @extends {React.Component<any, any>}
 */
class ContactWelcomeComponent extends React.Component<any, any> {
  render() {
    const { submitAction, values } = this.props;
    return(
      <ContactWelcomeLanding submitAction={submitAction} values={values} />
    );
  }
}

const mapDispatchToProps = AppConfigActions;

export const ContactWelcome = connect(
  null,
  mapDispatchToProps,
)(ContactWelcomeComponent);
